import throttle from 'lodash/throttle';
import reducedMotionActive from '../../../javascripts/helpers/reducedMotionActive';

const SCROLL_THRESHOLD = 300;

class BackToTop {
  constructor(element) {
    this.element = element;

    this.onScroll = throttle(() => this.handleScroll(), 100);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.element.addEventListener('click', () => this.scrollToTop());

    this.handleScroll();
  }

  handleScroll() {
    const visible = window.scrollY > SCROLL_THRESHOLD;
    this.element.classList.toggle('is-visible', visible);
  }

  scrollToTop() {
    // Im kontrastarmen / reduzierten Modus ohne Animation sofort nach oben springen.
    if (reducedMotionActive()) {
      window.scrollTo(0, 0);
      return;
    }

    const start = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
    const duration = 400;
    const startTime = performance.now();

    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start * (1 - easeOutCubic(progress)));
      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }
}

export default BackToTop;
